import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/apiClient'
import type { components } from '../lib/api-types'

export type Notice = components['schemas']['Notice']

/** The attention feed: unhealthy elements + likely cause + blast radius. Polls,
 *  because a god keeps watching. */
export function useNotices() {
  return useQuery({
    queryKey: ['notices'],
    refetchInterval: 15000,
    queryFn: async (): Promise<Notice[]> => {
      const { data, error } = await api.GET('/v1/notices')
      if (error || !data) throw new Error('Failed to load notices')
      return data
    },
  })
}
